import { ContactEdit } from '@client/components/contacts/ContactEdit';
import { createFileRoute } from '@tanstack/react-router';
export const Route = createFileRoute(
    '/console/$orgId/configuration/vendor-management/suppliers/list/details/$id/contacts/edit/$contactId',
)({
    staticData: {
        presentation: 'overlay',
        metadata: {
            title: 'Edit contact',
        },
    },
    params: {
        parse({ contactId }) {
            return { contactId: BigInt(contactId) };
        },
    },

    component: RouteComponent,
});

function RouteComponent() {
    const { id, contactId } = Route.useParams();

    return <ContactEdit action={['edit', contactId]} type="SUPPLIER" entity="supplier" entityId={id} />;
}
